import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle, AlertCircle, Send } from 'lucide-react';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${backendUrl}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Bir hata oluştu');
      }

      setSuccess(true);
      // Check if email was actually sent or token is provided as fallback
      if (data.reset_token) {
        setResetToken(data.reset_token);
        setEmailSent(false);
      } else {
        setEmailSent(true);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen pt-32 pb-20 px-4">
        <div className="max-w-md mx-auto">
          <div className="bg-white p-8 shadow-sm border">
            <div className="text-center mb-6">
              {emailSent ? (
                <>
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Send className="w-8 h-8 text-green-600" />
                  </div>
                  <h1 className="text-2xl font-light tracking-wider mb-2">E-posta Gönderildi!</h1>
                  <p className="text-gray-600 text-sm">
                    Şifre sıfırlama bağlantısı <strong>{email}</strong> adresine gönderildi.
                  </p>
                  <p className="text-gray-500 text-xs mt-2">
                    E-posta birkaç dakika içinde gelmezse spam klasörünüzü kontrol edin.
                  </p>
                </>
              ) : (
                <>
                  <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
                  <h1 className="text-2xl font-light tracking-wider mb-2">Bağlantı Oluşturuldu</h1>
                  <p className="text-gray-600 text-sm">
                    Şifre sıfırlama bağlantısı oluşturuldu. Bağlantı 1 saat geçerlidir.
                  </p>
                </>
              )}
            </div>

            {resetToken && (
              <div className="bg-yellow-50 border border-yellow-200 p-4 rounded mb-6">
                <p className="text-xs text-yellow-700 mb-2 flex items-center gap-1">
                  <AlertCircle size={14} />
                  E-posta servisi yapılandırılmamış. Aşağıdaki bağlantıyı kullanın:
                </p>
                <Link 
                  to={`/sifre-sifirla?token=${resetToken}`}
                  className="text-sm text-blue-600 hover:underline break-all block bg-white p-2 rounded border"
                >
                  Şifremi Sıfırla
                </Link>
              </div>
            )}

            <Link
              to="/giris"
              className="flex items-center justify-center gap-2 w-full bg-black text-white py-3 text-sm tracking-wider hover:bg-gray-900 transition-colors"
            >
              <ArrowLeft size={16} />
              Giriş Sayfasına Dön
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white p-8 shadow-sm border">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-light tracking-wider mb-2">ŞİFREMİ UNUTTUM</h1>
            <p className="text-gray-600 text-sm">
              E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
            </p>
          </div>

          {error && (
            <div className="flex items-center gap-2 bg-red-50 text-red-600 p-3 mb-4 text-sm">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">E-posta Adresi *</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="ornek@email.com"
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 focus:outline-none focus:border-black"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-black text-white py-3 text-sm tracking-wider hover:bg-gray-900 transition-colors disabled:opacity-50"
            >
              {isLoading ? 'GÖNDERİLİYOR...' : 'SIFIRLAMA BAĞLANTISI GÖNDER'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/giris" className="text-sm text-gray-600 hover:text-black flex items-center justify-center gap-2">
              <ArrowLeft size={14} />
              Giriş sayfasına dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
